module.exports = __webpack_public_path__ + "static/media/won_neon.32cd2d03.wav";